import type { Client } from "../client";
import type { DashboardConfigurationResource } from "../resources/dashboardConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";

export class DashboardConfigurationRepository extends ConfigurationRepository<DashboardConfigurationResource> {
    constructor(client: Client) {
        super("DashboardConfiguration", client);
    }
}
